import "../css/blockimage.css";
import { motion } from "framer-motion";

function BlockRightImage(props) {
  return (
    <>
      {" "}
      <div className="image-text-container">
        {/* Image Column */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8 }}
          className="image-column"
        >
          <img src={props.src} alt={props.alt}></img>
        </motion.div>
        {/* Text Column */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-column"
        >
          {props.content}
        </motion.div>
      </div>
    </>
  );
}

export default BlockRightImage;
